import * as React from 'react';
import { overrideCSS } from '../../utils/function';

const internalStyles = require('./Selector.pcss');
const FaAngleDown = require('react-icons/lib/fa/angle-down');

/*--- Interfaces ---*/

interface IState {
    visible? : boolean;
    options? : string[];
    title? : number;
}

interface IProps {
    title : number;
    options : string[];
    handleClick : Function;
    styles? : Object;
}

/*--- Component ---*/

export class Selector extends React.Component<IProps, IState>{

    constructor(props){
        super(props);

        this.state = { 
            visible: false,
            title : props.title,
            options: props.options
        };

        this.updateSelector = this.updateSelector.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
    }


    /**
     *  Toggles the dropdown for the selector
     */

    toggleDropdown() {
        let currentVisibility = this.state.visible;
        this.setState({ visible: !currentVisibility});
    }

    /**
     *  Updates the default on the selector
     * 
     *  @param {string} entry - Entry to update the selector to
     */

    updateSelector(entry: number) {
        let { handleClick } = this.props;

        this.setState({ 
            title: entry,
            visible: false 
        });

        handleClick(entry);
    }


    render() {
        let { options, title } = this.state;

        let styles = this.props.styles ? overrideCSS(internalStyles, this.props.styles) : internalStyles,
            visibility = this.state.visible ? styles.active : '',
            internalClasses = {
                dropdown : `${styles.dropdown} ${visibility}`,
                arrow : `${styles.arrow} ${visibility}`
            };

        return (
            <div className={styles.container}>
                <section className={styles.innerContainer}>
                    <div className={styles.selector} onClick={this.toggleDropdown}>
                        {options[title]}
                        <span className={styles.arrow}>
                            <FaAngleDown />
                        </span>
                    </div>

                    <section className={internalClasses.dropdown}>
                        <div className={styles.options}>
                            <ul>
                                {options.map((entry, i) => {
                                    let selected = i == 0 ? styles.selected : '';
                                    return (
                                        <li 
                                            key={i}
                                            onClick={() => this.updateSelector(i)} 
                                            className={`${styles.option} ${selected}`}>
                                            {entry}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </section>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/Selector/Selector.tsx